module.exports = {
  "CS_info2_Network_Image_HvHe": "网站上的图片",
  "CS_one_Batch_configuration_Ffmp": "批量配置",
  "CS_5_When_the_PbND": "当前进线人为乘客，仅支持使用乘客工具",
  "CS_one_Scenario_ENG_mFbn": "场景（en_US）",
  "CS_info_Comments_failed_mQNX": "评论失败",
  "CS_5_Do_not_kYRj": "请勿频繁操作",
  "CS_2_It_is_vdcu": "建议您优先使用In-App Message（会同时发送邮件通知）进行回复。如果您不知道该怎么做，请咨询您的主管。",
  "CS_1_Template_oNtV": "模板",
  "CS_tickets_User_Type_Wdya": "用户类型",
  "CS_info2_Please_fill_uLvw": "请填写",
  "CS_one_Operation_Log_hsdo": "操作日志",
  "CS_one_Tips_vbZx": "提示",
  "CS_one_Upload_successfully_DliZ": "上传成功，在完成新建后将在适用国家生效，请通知相关国家负责同事。",
  "CS_info2_Cancel_link_vxaa": "取消链接",
  "CS_1_Action_pnrH": "操作",
  "CS_pop_The_conversation_dKAF": "会话开始时间",
  "CS_one_Upload_files_TzsC": "上传文件",
  "CS_1_Operational_results_nOpZ": "操作结果",
  "CS_one_Please_check_SuZo": "2、请检查无误后，上传文件",
  "CS_1_Temporary_CTPp": "暂存",
  "CS_1_Solved_ooGh": "已解决",
  "CS_page_Unable_to_aXip": "工单创建失败",
  "CS_one_Enter_rfGy": "请输入",
  "CS_1_Message_Title_AJzH": "邮件标题",
  "CS_2_Worksheet_ID_SxiT": "工单创建时产生工单ID",
  "CS_2_Copy_the_hSGF": "复制手机号成功，本次行为已进行后台日志记录，请遵守公司信息安全规定！",
  "CS_one_Classification_of_qEgR": "问题分类管理",
  "ark.global.cs.field.values.ticket_tab_im": "在线客服",
  "CS_qa_This_behavior_dZrQ": "本次操作已进行后台日志记录，请遵守公司信息安全规定",
  "CS_Page_Driver_List_Uxwj": "司机列表",
  "CS_1_Thank_you_WUlL": "感谢您的评论！",
  "CS_info_Select_Question_QkZC": "请选择：问题分类",
  "CS_5_Your_query_uvJB": "你的查询次数已超过上限",
  "CS_one_Determination_GUbi": "确定",
  "CS_buchong_eFit_JNbR": "手机号输入错误/非注册用户，无法查询到订单信息",
  "CS_Page_Rider_Details_Ovwp": "乘客详情：乘客ID",
  "CS_1_Amount_mYAW": "金额",
  "CS_Page_Order_Details_oAUq": "订单详情：订单ID",
  "CS_Adjustment_YdjN_bXSL": "跳过SOP的原因不合理，请重新填入",
  "CS_Adjustment_gjOY_YpxQ": "SOP和PC信息不一致",
  "Fleet_0303_Fleet_WorkRegime_Contents_TAuX": "无内容",
  "CS_buchong__yLly": "手机号输入错误/非注册用户，无法使用工具",
  "CS_Tools_1209_Optimus_Coupon_Inuquiry_Scope_of_bBLW": "乘客ID ",
  "CS_one_Batch_effective_prPl": "批量生效",
  "CS_one_Country_and_Qyqv": "国家及业务线配置",
  "CS_page_Please_fill_ikWU": "请选择：工单组",
  "CS_tickets_Three_days_pcmE": "三天",
  "CS_one_New_Batch_wEKW": "批量新建",
  "CS_one_Abandoned_ROgG": "已废弃",
  "CS_1_Enter_content_haAO": "请输入内容",
  "CS_one_Description_ENG_vIZz": "描述（en_US）",
  "CS_page_Work_orders_MRDt": "工单关闭成功",
  "CS_one_Translation_configuration_lnQZ": "翻译配置",
  "CS_tickets_Compensation_deduction_GJfV": "补偿/扣款途径",
  "CS_info_Like_failure_mPup": "点赞失败",
  "CS_info2_Make_sure_zyfT": "请确保该工单无法获取到城市信息再选择此选项",
  "verify---id_no_co": "验证",
  "Help_version_Business_lines_VOJX": "业务线",
  "CS_4_Topographic_tools_KqUl": "地图工具",
  "CS_Page_Driver_Type_UnIR": "司机类型",
  "CS_information_Order_Basis_WKGU": "订单基础信息",
  "Magellan_improvement_The_company_CoIp": "司乘IM和通话记录等资料是公司保密数据。请根据公司信息安全规定合理使用。每次查询行为均会被后台日志记录。严禁拍照、下载或向任何公司外第三方泄露该数据",
  "CS_Page_Passenger_Details_vgGv": "乘客详情页",
  "CS_Service_The_driver's_JbyZ": "创建工单时司机的等级是{{driver_level}}",
  "CS_pop_No_xtIB": "否",
  "CS_pop_Cancel_byla": "取消",
  "Magellan_improvement_IM_Information_weuP": "IM信息",
  "CS_info2_Reset_Fiiu": "重置",
  "CS_1_E_mail_rKAg": "电子邮件",
  "CS_tickets_Administrator_BcHW": "管理员",
  "CS_one_Action_Type_uHTo": "操作类型",
  "Magellan_improvement_Question_description_GyVD": "问题描述",
  "CS_page_Do_you_UfOG": "是否要将工单流转至{{ticketgroup}}组？",
  "CS_page_Transportation_orders_UWhR": "流转工单",
  "CS_tickets_One_month_IrdR": "一个月",
  "CS_5_Unchecked_user_vuUZ": "未查询到用户注册信息",
  "CS_Settings_Countless_lEdc": "无数据",
  "CS_page_Transferring_the_ZnkX": "流转工单成功",
  "Magellan_improvement_Call_completed_hbKz": "通话完成",
  "CS_improvement_Passenger_JnXD": "乘客",
  "CS_Page_Driver_Basic_SItd": "司机基本信息",
  "CS_one_Description_NrBC": "描述",
  "CS_Adjustment_abEf_PYol": "SOP出现bug",
  "CS_4_Tools_can_ZQSK": "所有工具仅支持在CS系统中工单处理页使用",
  "CS_one_Owner_EwUa": "所有者",
  "CS_Page_Model_List_WVIO": "车型列表",
  "CS_Page_Common_tools_FTJG": "常用工具",
  "CS_info_Click_here_MKRf": "点击此处可关联1个订单",
  "CS_thpoptimization__sSiH": "车头",
  "CS_3_Optional_kdMP": "可选",
  "CS_pop_User_Phone_hTGd": "用户电话号码",
  "CS_Page_City_name_atjF": "城市名称",
  "CS_Service_Driver_Level_qpqY": "司机等级",
  "CS_improvement_Call_SmCo": "拨打电话时间",
  "Help_version_Enter_number_MyWJ": "进线号码",
  "CS_1_Comments_RcMN": "评论",
  "CS_info_This_page_Cpww": "本页面最多仅可打开10个工单处理页，以免造成系统卡顿。请关闭不需要处理的页面，谢谢。",
  "CS_tickets_Work_order_NQJE": "工单状态",
  "CS_one_Entered_into_mEwl": "已生效",
  "CS_Adjustment_txhj_lfbO": "请先完成SOP再进行操作",
  "CS_tickets_Three_months_Jdzc": "三个月",
  "CS_1_Order_ID_bsCY": "订单ID",
  "CS_tool_Work_order_LjeC": "工单状态",
  "CS_Page_Trip_Compl_Vcnk": "订单完成时间",
  "CS_page_No_permissions_mYZG": "没有流转工单的权限",
  "CS_1_Send_email_DDPi": "发送电子邮件确认",
  "CS_buchong__BYdr": "手机号输入错误/非注册用户，无法查询到用户信息或使用动态权限验真功能。",
  "CS_one_New_Problem_ORNp": "新建问题分类",
  "CS_Page_Select_the_kqHS": "请选择筛选条件",
  "Help_version_Country_XKEj": "国家",
  "CS_translation_Selection_of_yatg": "选择补偿原因",
  "CS_2_Please_select_Zapc": "请选择",
  "CS_2_Refund_amount_ikWV": "退款金额",
  "CS_Page_Enter_Order_TeQM": "请输入订单ID",
  "CS_Page_Type_SnKr": "型号",
  "CS_QA1_More_than_uScx": "超过{{amount}}条，只展示{{amount}}条",
  "CS_one_Operation_Records_bTgJ": "操作记录",
  "CS_1_ID_VNVI": "工单id",
  "CS_pop_Bind_session_qEwk": "绑定会话",
  "CS_info2_Jump_link_pUcH": "跳转链接",
  "CS_tickets_The_user_iVJx": "该用户是车头管理员，（点击查看详情）",
  "ark.global.cs.field.values.ticket_tab_compensation": "处置记录",
  "CS_info2_Depositary_UmEY": "处理人",
  "CS_initialization_Create_a_xRhB": "请先创建工单",
  "CS_pop_Bind_lDQM": "绑定",
  "CS_Page_Order_List_IiWy": "订单列表",
  "CS_one_Status_QWZW": "状态",
  "CS_page_Site_Name_dYcm": "站点名",
  "CS_information_Single_phone_vKdi": "发单人电话",
  "CS_page__unk_uZmz": "小巴信息",
  "CS_2_Driver_balance_otCh": "司机余额扣款",
  "CS_Notice_Please_submit_iVZB": "请您在填写对此流程卡片的建议后提交",
  "CS_info2_Link_kBeS": "关联",
  "CS_1_You_do_Czvx": "您没有查看用户隐私信息的权限，请进行系统验真或联系管理员",
  "CS_info_Process_cards_ccmd": "流程卡片",
  "CS_improvement_The_main_DIgv": "主叫挂断",
  "Help_2_More_OZUg": "更多",
  "CS_1_Recipients_jNBa": "收件人",
  "CS_buchong1__XPiG": "未通过动态权限验证功能，无法操作。请进行动态权限验证或联系管理员",
  "CS_Page_Enter_email_VDKC": "请输入邮箱地址",
  "CS_one_Return_axWQ": "返回",
  "CS_tickets_Complaint_Manner_UWAQ": "被投诉人工单",
  "CS_2_Refundable_mKnQ": "是否可退款",
  "CS_pop_Whether_to_tvgd": "是否创建不关联会话的工单",
  "CS_1_Send_an_oyHo": "是否给用户发送电子邮件?",
  "CS_one_Upload_failed_tubs": "上传失败，请重新尝试",
  "CS_tickets_Order_Work_UDue": "订单工单",
  "Magellan_improvement_ID_HTMT": "工单ID",
  "CS_Page_Type_of_Chyl": "查询类型",
  "CS_initialization_Select_user_QGGG": "请选择用户类型",
  "Help_version_Answer_DVQw": "接听",
  "CS_improvement_Dial_man_vuMm": "拨号人",
  "CS_one_Are_you_QXby": "您确定要修改本条问题分类么？在完成修改完成后将在适用国家生效，请通知相关国家负责同事。",
  "CS_info2_Data_Not_mVCx": "无数据",
  "CS_information_Purpose_tIXL": "目的地",
  "CS_Page_Response_mode_tfSQ": "应答模式",
  "CS_Page_Order_Status_ZJEQ": "订单状态",
  "CS_1_Internal_message_Dmzz": "内部留言",
  "CS_1_More_online_ugOQ": "更多在线客服记录",
  "CS_page_Cancelled_xyYr": "已取消",
  "CS_one_1_Please_EOBr": "1、请先下载以下模板，填写完毕后再上传文件，否则系统无法识别",
  "CS_one_Applicable_States_HNdh": "适用国家",
  "CS_translation_Submission_akuK": "提交",
  "CS_one_Basic_information_akKk": "基础信息",
  "CS_Page_Driver_Mobile_mQCL": "司机手机号码",
  "CS_one_Father_classification_ZASx": "父级分类level 1（en_US）",
  "CS_info_Select_user_WEYA": "请选择用户类型及业务线来获取问题分类",
  "CS_information_Order_Status_ZZvi": "订单状态",
  "CS_Page_Please_choose_SkUr": "请选择...",
  "CS_one_Import_data_zhsI": "导入数据",
  "CS_one_Applicable_Business_ERQA": "适用业务类型",
  "CS_1_Off_aqDQ": "关闭",
  "CS_info2__unk_MkzP": "上传图片",
  "CS_qa_Successfully_saved_GaYt": "工单保存成功",
  "CS_info2_User_Type_ylaU": "用户类型",
  "CS_1_Send_asynchronous_rowd": "发送异步消息和邮件通知",
  "CS_1_Cancel_UVIs": "取消",
  "CS_info2_link_Text_Gvnh": "关联信息",
  "CS_Page_Enter_Passenger_vcdv": "请输入乘客ID",
  "CS_one_Cancel_sSYi": "取消",
  "CS_one_Add_VToU": "新增",
  "CS_one_Download_Template_XYvP": "下载模板",
  "CS_tickets_Compensation_Deducperiod_HFiB": "补偿/扣款执行时间",
  "CS_info2_Picture_text_mnMQ": "图片文字说明",
  "CS_1_User_Mobile_aNYY": "用户手机号",
  "CS_Page_Product_line_gPCE": "产品线",
  "CS_info_There_is_vxeJ": "在这个问题分类下没有内容，请查看（知识库）",
  "CS_tickets_Today_klqB": "今天",
  "CS_notification_dwyv_UnUJ": "当前进线人为车头，仅支持使用车头工具",
  "CS_tickets_Search_dVXa": "搜索",
  "CS_improvement_Driver_ZOiL": "司机",
  "CS_one_Scenarios_qeVe": "场景",
  "CS_reconstruction_Determination_MvvP": "确定",
  "CS_2_Time_of_ynEo": "退款时间",
  "CS_1_operator_gItF": "操作人",
  "CS_info2_Image_address_QJoY": "图片地址",
  "CS_tickets_Type_of_DvxN": "工单类型",
  "CS_tickets_Half_a_SjoS": "半年",
  "CS_info_Into_the_OLWz": "进线人信息",
  "CS_page_Unable_to_sJgg": "工单已解决失败",
  "CS_1_Passengers_rXbp": "乘客",
  "CS_page_Unable_to_lQkV": "工单关闭失败",
  "CS_1_Compensation_Deduction_eyNT": "补偿/扣款详情",
  "CS_page_Unable_to_lWwm": "暂存工单失败",
  "CS_Page_Passenger_ID_WiFY": "乘客ID",
  "CS_Page_Clear_Query_qLSf": "清除查询条件",
  "CS_info2_View_link_fyZT": "查看链接",
  "CS_tickets_Work_order_STXN": "工单历史",
  "CS_2_Copy_successfully_rlpe": "复制成功",
  "CS_one_Grade_classification_sVNq": "父级分类",
  "CS_Page_Driver_Details_Mnzk": "司机详情页",
  "CS_page_Successful_temporary_sFHU": "暂存工单成功",
  "CS_page_Successfully_created_ffvZ": "工单创建成功",
  "CS_Page_Purpose_rNGk": "目的地",
  "CS_Tools_1231_Optimus_AdyenTool_Failure_TWRQ": "失败",
  "CS_thpoptimization_Copy_the_CPlW": "邮箱号复制成功。本次行为已进行后台日志记录，请遵守公司信息安全规定",
  "CS_1_Status_of_Dkxj": "执行状态",
  "CS_Adjustment_VsHy_RwJo": "请填写跳过原因",
  "CS_reconstruction_Select_Business_DYpG": "请选择业务类型",
  "CS_Settings_Can_not_wuTx": "不能为空",
  "CS_1_Action_Name_sFel": "操作名称",
  "CS_Page_Driver_Details_uNcn": "司机详情：司机ID",
  "CS_pop_Action_zZIq": "操作",
  "CS_pop_Confirmation_lTpQ": "确认",
  "CS_improvement_Phone_records_Kgdt": "通话记录",
  "Help_buchong_Reply_RcHf": "回复",
  "CS_one_Classification_of_YYEd": "是否为安全问题分类",
  "CS_info2_Association_ZCdq": "关联",
  "CS_1_Work_orders_fADf": "工单发送内部留言成功",
  "CS_qa_Collapse_DJRI": "收起",
  "CS_improvement_Voice_duration_TNdW": "语音持续时间",
  "CS_1_Work_order_pUHt": "工单发送电子邮件成功",
  "CS_1_Mail_address_Hxvv": "邮件地址",
  "CS_page_Actual_arrival_YPiM": "实际到站时间",
  "CS_Page_Driver_ID_HNzY": "司机ID",
  "CS_info_Select_a_CKYG": "请选择一个城市，如果无法获取城市信息可以选择N/A",
  "Magellan_improvement_When_you_WyDX": "您关闭订单后，订单将被取消。请慎重选择。",
  "CS_tickets_Compensation_ID_PjEu": "补偿ID",
  "CS_5_When_the_WPIZ": "当前进线人为司机，仅支持使用司机工具",
  "CS_one_Please_confirm_BmHM": "请确认选择的问题分类，点击“确定”后即可生效。",
  "CS_1_Send_email_oriC": "发送电子邮件",
  "CS_tickets_One_week_YsBK": "一周",
  "CS_page_Whether_the_pGhP": "是否确定此工单已解决？确认后工单状态将变为【处理中】",
  "CS_one_Off_Zqiv": "关闭",
  "CS_2_For_security_YqmP": "出于安全原因，收件人的电子邮箱地址已加密,它不会影响你的交流。",
  "CS_info_Please_fill_yjjm": "请填写：手机号",
  "CS_info2_Business_Type_KDsP": "业务类型",
  "CS_1_Send_internal_kufI": "发送内部留言",
  "CS_1_Save_dSGz": "保存",
  "CS_page_Priority_processor_Gwtc": "优先处理人",
  "CS_1_The_author_xIBI": "发件人",
  "CS_one_Details_Page_mdDC": "问题分类详情页",
  "CS_page_If_you_RZwt": "是否确认暂存此工单？确认后工单状态将变为【暂存中】",
  "CS_page_Work_order_vikw": "工单已解决成功",
  "CS_1_Type_kuvZ": "类型",
  "CS_1_Role_QhMU": "角色",
  "CS_one_Please_confirm_ViBj": "请确认选择的问题分类，点击“确定”后即可废弃。",
  "CS_2_Refund_history_NZXS": "退款历史记录",
  "CS_info2_Related_Worksheets_TnzD": "关联工单（可选）",
  "CS_page_This_order_jAmf": "该订单相关站点",
  "CS_Page_City_XSgD": "城市",
  "CS_qa_Customer_Service_CeXF": "客服",
  "CS_Page_Passenger_List_ajVZ": "乘客列表",
  "CS_1_Latest_before_UTUl": "最新在前",
  "CS_5_Copy_successfully_CcCu": "复制成功",
  "CS_1_During_Operation_xWpb": "操作时间",
  "CS_one_Please_select_IHKO": "请选择国家及业务线",
  "CS_one_During_Operation_JDju": "操作时间",
  "CS_qa_More_Paqa": "更多",
  "CS_info_Select_Channel_HWlg": "请选择：渠道",
  "CS_info2_Rider_Issuing_TDAx": "乘客发单时间",
  "CS_4_Contact_Records_NcjV": "联系记录",
  "ark.global.cs.TOOL_ACTION_associated_ticket": "关联工单",
  "Magellan_improvement_Information_Secure_LRtP": "信息保密提示",
  "CS_Page_Enter_driver_CirL": "请输入司机ID",
  "CS_Page_Select_driver_rrhQ": "请选择司机类型",
  "CS_qa_There_is_vPke": "{{inputbox}}中有未发送的内容，离开后将会清空内容，你确定要离开吗？",
  "CS_one_Father_classification_lZII": "父级分类level 2（en_US）",
  "CS_info_Mobile_phone_SGyc": "手机号输入错误/非注册用户，无法查询到用户信息",
  "CS_one_Export_data_YQDj": "导出数据",
  "CS_information_Departure_zaxW": "出发地",
  "CS_TicketHandlingPage_This_CR_VWpW": "本问题分类已经支持人工SOP，请按照SOP处理本工单。",
  "CS_2_Work_Order_anVq": "工单组",
  "CS_info_Select_Business_bhhu": "请选择：业务类型",
  "CS_Adjustment_ZMnG_gsAL": "其他",
  "CS_information_Order_ID_vVme": "订单ID",
  "CS_one_User_Type_iRnJ": "用户类型",
  "CS_4_Order_details_ulUl": "订单细节",
  "CS_one_Edit_LtHm": "编辑",
  "CS_info2_If_there_BivS": "如有关联的工单，请选择",
  "CS_Page_Billing_models_otMq": "计费车型",
  "CS_Page_Enter_your_kKAs": "请输入手机号码",
  "CS_page_No_email_Uhdl": "无邮件回复权限",
  "CS_Adjustment_VZmt_VnjZ": "请选择跳过原因",
  "CS_Adjustment_oVPm_qPQP": "用户下线或放弃对话",
  "CS_one_View_miAp": "查看",
  "CS_fits_OUZR_woGE": "订单产品线",
  "CS_1_Compensation_deduction_pTJS": "补偿/扣款途径",
  "CS_info2_More_akQx": "更多",
  "CS_1_Work_orders_cLNO": "工单发送异步消息成功",
  "CS_1_Roaming_wzIe": "漫游",
  "CS_5_Copy_qVgF": "复制",
  "CS_Page_Star_Standard_ICmt": "星级标准",
  "CS_page_Estimated_arrival_QwhV": "预计到站时间",
  "CS_compensation_Refusal_of_hveW": "拒绝补偿",
  "CS_initialization_Select_Order_dqhz": "请选择订单",
  "CS_TicketHandlingPage_Artificial_SOP_vwXh": "人工SOP",
  "CS_Page_Passenger_Email_qveC": "乘客邮箱",
  "CS_Page_Between_the_eqMJ": "创建时间",
  "CS_Page_Business_Type_nsHy": "业务类型",
  "CS_page_Do_you_tMFN": "是否要关闭此工单？",
  "CS_2_Work_Order_fABY": "工单ID复制成功",
  "CS_Page_Pick_up_CNzD": "接驾地点",
  "More": "更多",
  "CS_improvement_Unanswered_qcLt": "无应答",
  "CS_1_Related_Orders_hkRo": "关联订单",
  "CS_info_Comments_successfully_YcZj": "评论成功",
  "CS_tickets_Enter_the_FCWt": "进线人工单",
  "CS_information_Booking_session_CBQY": "预约时间",
  "ark.global.cs.field.values.ticket_tab_inner_reply": "内部留言",
  "CS_Page_Driver_ID_TPqW": "司机身份证号",
  "CS_info_Select_Work_KXNc": "请选择：工单组",
  "Help_conversations_Robot_chat_QzDc": "机器人聊天记录",
  "CS_tickets_Between_the_mEqx": "创建时间",
  "CS_2_Passenger_Basic_FFNN": "乘客基本信息",
  "CS_page_Do_you_GgIB": "是否要将工单流转至{{ticketgroup}}组{{handler}}人？",
  "CS_1_Enter_text_NYGo": "请输入文字",
  "CS_1_Compensation_ID_BGFF": "补偿ID",
  "CS_1_Work_order_wyuA": "工单信息",
  "CS_info_Select_User_rSZo": "请选择：用户类型",
  "CS_one_Classification_of_QAlG": "问题分类",
  "ark.global.cs.field.values.ticket_tab_asyc_msg": "异步消息",
  "CS_pop_Can_t_QjXi": "找不到对应的会话？",
  "Help_version_Telephone_entry_PGun": "电话条",
  "CS_one_You_can_MflO": "不能输入特殊符号，“（）”、“？”、“空格”除外",
  "ark.global.cs.field.values.ticket_tab_outer_reply": "外部回复",
  "CS_one_operator_Itcg": "操作人",
  "CS_one_Organization_eUqC": "组织",
  "CS_5_Comply_with_YDuq": "遵守公司信息安全规定！",
  "CS_prompt_Driver_registration_mBqS": "未查询到司机注册审核任务",
  "CS_Page_Order_ID_tWzK": "订单ID",
  "CS_one_Classification_of_jyqM": "问题分类（en_US）",
  "CS_Page_Status_of_SBuB": "支付状态",
  "CS_Page_Enter_ID_IgwX": "请输入身份证号",
  "TEXT_ERRMSG_OK": "成功",
  "Help_want__Change_pUeS": "换一换",
  "Help_version_Thread_tmgY": "进线问题",
  "CS_Page_Passenger_Mobile_ckjq": "乘客手机号码",
  "CS_qa_User_Tjti": "用户",
  "CS_one_Classification_of_AlnN": "问题分类（en_US）",
  "CS_1_Help_us_ilXL": "帮助我们做的更好",
  "CS_one_Are_you_eqhN": "您确定要新建本条问题分类么？在完成新建完成后将在适用国家生效，请通知相关国家负责同事。",
  "CS_initialization_Select_City_uKvx": "请选择城市",
  "CS_pop_Bind_fsRd": "已绑定",
  "CS_2_Classification_of_QmXS": "问题分类",
  "kfcommon-fe-i18n-knowledge---knowledgeConfig.robot": "机器人",
  "ark.global.cs.field.title.ticket_tab_log": "工单日志",
  "CS_pop_Yes_yDMc": "是",
  "CS_tickets_One_year_gmPi": "一年",
  "CS_page_Internal_reply_pruf": "内部回复不能为空",
  "ark.global.cs.field.title.ticket_tab_info": "信息记录",
  "CS_Page_Front_ID_apqL": "车头详情：车头ID",
  "CS_1_User_Name_dhWx": "用户姓名",
  "CS_one_Batch_scrap_qzlO": "批量废弃",
  "CS_info2__unk_RIxc": "插入",
  "CS_Tools_colombo_tool_platform_Cancel_gNzm": "取消",
  "CS_one_Parental_classification_zEhp": "父级分类（en_US）",
  "Help_buchong_Reply_Record_dsUU": "回复记录",
  "CS_info2_All_orders_yVmI": "已经展示该用户180天内的所有订单",
  "CS_1_The_oldest_vXHS": "最老在前",
  "CS_monitor_Each_compensation_BfxO": "每个补偿申请均会被后台日志记录。请根据客服补偿政策提交申请。不符合流程的申请将被内部审核。",
  "comTool.channelRefundERR": "当前订单没有账单，不支持原渠道退款",
  "review.auditInfo": "结果详情",
  "list.orderId": "订单ID",
  "comTool.refundStatus": "退款状态",
  "common.pleaseSelect": "请选择 ",
  "new.tags": "标签",
  "comfort.vehicleModel": "车型列表",
  "comfort.requiredYear": "出场年份 >",
  "chat.save": "保存",
  "review.submitReview": "提交审核",
  "new.continueHandle": "继续处理",
  "comTool.driverV": "无法进行补偿，因为用户类型为乘客",
  "comTool.balance": "余额",
  "automation.action": "动作",
  "list.compensatePhone": "用户手机",
  "staticConfig.false": "否",
  "work.businessTypeName": "业务类型",
  "new.orderInfo": "订单信息",
  "review.viewFlowchart": "查看完整流程图",
  "comTool.riderCompensation": "乘客补偿",
  "comTool.driverActualRevenue": "司机实际收款",
  "comTool.driverId": "司机ID",
  "new.knowdgeBase": "知识库",
  "comTool.passenger": "乘客",
  "list.channel": "渠道",
  "clipper.clipperTitle": "关联的Clipper安全工单信息",
  "comTool.reasonForCompensation": "补偿原因",
  "comTool.driverPhone": "司机电话",
  "review.commitTime": "提交时间",
  "common.system": "系统",
  "common.more": "展开",
  "comTool.amountERR": "金额输入错误",
  "staticConfig.yes": "是",
  "staticConfig.operationSuccessfully": "操作成功",
  "list.worksheetId": "工单ID",
  "comTool.status": "支付状态",
  "comTool.driverDeduction": "司机扣款",
  "new.ticketRefreshV": "工单信息已经被更新，是否继续处理",
  "common.jingmoThreeMonths": "只展示近三个月的静默日志",
  "comTool.refundCost": "已退金额",
  "list.amount": "金额",
  "review.auditor": "审核人",
  "common.Toolbox": "工具箱",
  "common.ticketList": "工单列表",
  "comfort.city": "城市",
  "review.taskName": "审核任务类型",
  "staticConfig.channelSetting": "渠道设置",
  "comTool.detailsOfCompensation": "补偿内容详情",
  "clipper.clipperDetail": "该工单有一个相关联的Clipper安全工单",
  "comTool.driverCompensation": "司机补偿",
  "review.submitReviewConfirm": "请确认是否提交审核",
  "new.uploadFailed": "上传失败，请重试",
  "comTool.operationStatus": "结果",
  "clipper.status": "Clipper工单状态",
  "review.actions": "操作",
  "comTool.passengerCouponV": "无法请求补偿优惠券，因为用户类型为司机",
  "work.Workbench": "我的工作台",
  "comTool.cost": "支付金额",
  "chat.transfer": "流转升级",
  "chat.onlineResponse": "异步消息",
  "review.auditTime": "审核时间",
  "staticConfig.no": "否",
  "staticConfig.businessTypeName": "业务类型",
  "new.NullEmergencyContact": "用户未设置紧急联系人",
  "new.emergencyContact": "紧急联系人",
  "common.confirm": "确认",
  "comfort.model": "型号",
  "clipper.T3first": "Clipper T3开始处理时间",
  "common.abnormalReminder": "异常提醒",
  "new.editTime": "编辑时间",
  "comTool.pay": "乘客钱包补偿",
  "review.undoChanges": "取消更改",
  "comTool.channelName": "渠道名称",
  "callInfo.operation": "操作",
  "clipper.creationDate": "Clipper建单时间",
  "common.continueTocompensate": "仍要补偿",
  "comTool.coupon": "代金券",
  "list.amountRange": "金额范围",
  "comTool.channelRefund": "原渠道退款",
  "clipper.ticketID": "Clipper工单编号",
  "comfort.search": "查询",
  "clipper.T2first": "Clipper T2开始处理时间",
  "new.PleaseCreateTicket": "请先创建工单",
  "comTool.refund": "退款",
  "detail.handle": "处理",
  "new.fileBig": "文件过大，请选择小于5M的文件",
  "create.NewTicket": "新工单",
  "staticConfig.true": "是",
  "review.auditResult": "审核结果",
  "new.editUser": "编辑人",
  "review.modify": "编辑",
  "detail.handleV": "当前工单已有客服正在处理，是否还要强制领取",
  "new.refreshTicket": "刷新工单",
  "comTool.routeOfCompensation": "补偿途径",
  "common.recommendationNotcompensate": "建议不补偿。",
  "common.to": "变更为",
  "comTool.noOrderAll": "当前工单没有订单，不支持补偿",
  "clipper.clickToView": "点击查看",
  "common.up": "收起"
}